import { Instagram, Mail, MessageCircle, MapPin, Clock } from "lucide-react";
import Logo from "@/components/Logo";
import { waLink, PRESET } from "@/lib/whatsapp";

export const Footer = ({ t, lang }) => {
  const generalMsg = lang === "es" ? PRESET.generalEs : PRESET.generalEn;
  return (
    <footer
      className="relative bg-bendito-bg border-t border-bendito-border"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 text-bendito-muted text-sm max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
            <a
              href="https://www.instagram.com/benditotattoo.pdc/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 text-bendito-ink hover:text-bendito-orange transition-colors"
              data-testid="footer-ig-link"
            >
              <Instagram size={18} strokeWidth={1.5} />
              <span className="font-mono text-xs tracking-[0.25em]">@benditotattoo.pdc</span>
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-bendito-orange mb-4">
              {t.footer.quickLinks}
            </div>
            <ul className="space-y-1 text-sm">
              <li>
                <a href="#work" className="inline-block py-2 text-bendito-ink/90 hover:text-bendito-orange transition-colors" data-testid="footer-link-work">
                  {t.nav.work}
                </a>
              </li>
              <li>
                <a href="#artists" className="inline-block py-2 text-bendito-ink/90 hover:text-bendito-orange transition-colors" data-testid="footer-link-artists">
                  {t.nav.artists}
                </a>
              </li>
              <li>
                <a href="#quote" className="inline-block py-2 text-bendito-ink/90 hover:text-bendito-orange transition-colors" data-testid="footer-link-quote">
                  {t.nav.quote}
                </a>
              </li>
              <li>
                <a href="#faq" className="inline-block py-2 text-bendito-ink/90 hover:text-bendito-orange transition-colors" data-testid="footer-link-faq">
                  {t.nav.faq}
                </a>
              </li>
            </ul>

            <div className="mt-6 font-mono text-[11px] tracking-[0.3em] uppercase text-bendito-orange mb-3">
              {t.footer.followArtists}
            </div>
            <ul className="space-y-2 text-xs text-bendito-muted">
              <li><a href="https://www.instagram.com/eeme_tattoo/" target="_blank" rel="noopener noreferrer" className="hover:text-bendito-orange transition-colors">@eeme_tattoo</a></li>
              <li><a href="https://www.instagram.com/may.tattooer/" target="_blank" rel="noopener noreferrer" className="hover:text-bendito-orange transition-colors">@may.tattooer</a></li>
              <li><a href="https://www.instagram.com/tysos_pastel/" target="_blank" rel="noopener noreferrer" className="hover:text-bendito-orange transition-colors">@tysos_pastel</a></li>
              <li><a href="https://www.instagram.com/dziczektattoo/" target="_blank" rel="noopener noreferrer" className="hover:text-bendito-orange transition-colors">@dziczektattoo</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-bendito-orange mb-4">
              {t.footer.contact}
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MessageCircle size={16} className="text-bendito-orange shrink-0 mt-0.5" strokeWidth={1.5} />
                <a
                  href={waLink(generalMsg)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-bendito-ink/90 hover:text-bendito-orange transition-colors"
                  data-testid="footer-whatsapp"
                >
                  +52 1 984 498 5289
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-bendito-orange shrink-0 mt-0.5" strokeWidth={1.5} />
                <a
                  href="mailto:thebenditotattoo@gmail.com"
                  className="text-bendito-ink/90 hover:text-bendito-orange transition-colors break-all"
                  data-testid="footer-email"
                >
                  thebenditotattoo@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-bendito-orange shrink-0 mt-0.5" strokeWidth={1.5} />
                <span className="text-bendito-ink/90">Playa del Carmen, Q. Roo, México</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} className="text-bendito-orange shrink-0 mt-0.5" strokeWidth={1.5} />
                <span className="text-bendito-ink/90">{t.footer.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-bendito-border flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs font-mono tracking-wide text-bendito-dim">
          <div>© {new Date().getFullYear()} Bendito Tattoo. {t.footer.rights}</div>
          <div>{t.footer.builtBy}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
